"use client";

import { useState, useEffect } from "react";

export default function Leaderboard() {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await fetch(
          "https://igandhebr6.execute-api.us-west-1.amazonaws.com/dev/leaderboard",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`API request failed: ${response.statusText}`);
        }

        const data = await response.json();
        if (data.leaderboard) {
          setLeaderboardData(data.leaderboard);
        } else {
          setError("Leaderboard data is missing.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h2 className="text-white text-2xl">Loading Leaderboard...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h2 className="text-red-500 text-2xl">Error: {error}</h2>
      </div>
    );
  }

  return (
    <main className="min-h-screen w-full relative">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-10"
        style={{
          backgroundImage: "url(../assets/images/user-login-bg.png)",
        }}
      />

      {/* Leaderboard Container */}
      <div className="container mx-auto px-4 py-8">
        {/* Title */}
        <h1
          className="text-7xl font-bold text-white mb-16 text-center leadership-text tracking-widest"
        >
          Leader Board
        </h1>

        {/* Leaderboard Entries */}
        <div className="space-y-8 px-4 mx-auto w-[75%]">
          {/* Header Row */}
          <div className="grid grid-cols-12 gap-4 mb-6">
            <div className="col-span-3 text-white text-2xl tracking-wider">
              RANK
            </div>
            <div className="col-span-6 text-white text-2xl tracking-wider">
              NAME
            </div>
            <div className="col-span-3 text-white text-2xl tracking-wider">
              SCORE
            </div>
          </div>

          {leaderboardData.map((entry) => (
            <div
              key={entry.rank}
              className="relative flex items-center h-20 rounded-lg overflow-hidden leadership-shadow"
            >
              {/* Green Background */}
              <div className="absolute inset-0 bg-[#57ba98] rounded-lg"></div>

              {/* Rank Section */}
              <div className="relative z-10 flex items-center justify-center w-48 h-full bg-[#57ba98] text-white text-3xl font-bold rounded-l-lg">
                {entry.rank}
              </div>

              {/* Name Section */}
              <div
                className="relative z-20 flex-1 h-full flex items-center justify-center bg-[#57ba98] text-white text-2xl font-bold"
                style={{
                  backgroundImage:
                    "url(../assets/images/arrow-bg-image.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                }}
              >
                {entry.name}
              </div>

              {/* Score Section */}
              <div className="relative z-10 flex items-center justify-center w-48 h-full bg-[#57ba98] text-white text-3xl font-bold rounded-r-lg">
                {Math.round(entry.score)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
